import styled from 'styled-components';

import { CustomThemeToken } from '@/theme';

export const ContentContainer = styled.div<{ theme: { token: CustomThemeToken } }>`
  min-height: ${({ theme: { token } }) => `${token.marginXXL * 4}px`};
`;
